import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import clsx from "clsx";
import SectionContainer from "./SectionContainer";
import { comparisonCards } from "../../data/landingData";

const titleKeys: Record<string, string> = {
  traditional: "comparison_traditional_title",
  generic: "comparison_generic_title",
  us: "comparison_us_title",
};

const ComparisonSection: React.FC = () => {
  const { t } = useTranslation("home");

  return (
    <SectionContainer fullWidthBg bgClassName="bg-space-light/30">
      <motion.h2
        className="text-h2 text-center mb-12 text-white"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        {t("comparison_title")}
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {comparisonCards.map((card, index) => {
          const isUs = card.variant === "us";
          const icon =
            card.variant === "traditional"
              ? "❌"
              : card.variant === "generic"
              ? "⚠️"
              : "✅";

          return (
            <motion.div
              key={card.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={clsx(
                "rounded-2xl p-6 md:p-8 bg-space/80 backdrop-blur-sm",
                "border shadow-lg",
                isUs
                  ? "border-neon-green border-2 scale-100 md:scale-105 glow-green z-10"
                  : "border-white/10"
              )}
            >
              <h3
                className={clsx(
                  "text-h3 mb-6",
                  isUs ? "text-neon-green" : "text-gray-200"
                )}
              >
                {t(titleKeys[card.variant])}
              </h3>
              <ul className="space-y-4">
                {card.items.map((key) => (
                  <li
                    key={key}
                    className="flex items-start gap-3 text-body-sm text-gray-300"
                  >
                    <span className="shrink-0 mt-0.5">{icon}</span>
                    <span>{t(key)}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          );
        })}
      </div>
    </SectionContainer>
  );
};

export default ComparisonSection;
